/*
 * � 2020 Microsoft. All rights reserved.
 */

define(
	'MenuUI/NewsDialog',['absolute', 'Solitaire/MvvmStructure/Service/NewsService', 'util/SettingsManager'],
	function (
		Absolute, NewsService, SettingsManager
	) {
		"use strict";

		var NewsDialog = function () {
			this.initNewsDialog();
		};

		NewsDialog.prototype.initNewsDialog = function () {
			this.overlayContainer = document.getElementById("overlayContentWrapper");
			this.news = document.getElementById("news");
			this.newsOverlay = document.getElementById("htmlBoxOverlay");
			this.newsCloseButton = document.getElementById("closenews");
			this.newsCloseButton.onmouseup = this.newsCloseButton.ontouchstart = function () {
				this.hide();
			}.bind(this);
			jQuery(this.overlayContainer).bind('mousewheel', function (e) {
				e.stopPropagation();
				e.preventDefault();
			});
		};

		NewsDialog.prototype.show = function (autoTriggered, callback, closeCallback) {

			var newsBuilt = false;

			autoTriggered = !!autoTriggered;

			this.closeCallback = closeCallback;

			this.getNewsData(function () {
				if (autoTriggered) {
					var today = Date.now();
					if (this._expirationDate && today < this._expirationDate.getTime() && !SettingsManager.getSetting('motd', this._id)) {
						newsBuilt = this.buildNews();
					}
				} else {
					newsBuilt = this.buildNews();
				}
				if (callback) {
					callback(newsBuilt);
				}
			}.bind(this));
		};

		NewsDialog.prototype.shouldShowLink = function (callback) {
			this.getNewsData(function () {
				callback(!!(this._expirationDate && Date.now() < this._expirationDate.getTime()));
			}.bind(this));
		};

		NewsDialog.prototype.newsAvailable = function () {
			return this._expirationDate && Date.now() < this._expirationDate.getTime();
		};

		NewsDialog.prototype.getNewsData = function (callback) {
			if (this._messageDate && this._headerImage && this._content) {
				if (callback) {
					callback();
				}
			} else {
				NewsService.GetLatestNews(
					function (data) {
						var news = data.News[0];
						this._messageDate = new Date(news.MessageDate);
						this._expirationDate = new Date(news.ExpirationDate);
						this._headerImage = news.ImageUrl;
						this._content = news.MessageBlock;
						this._id = news.MessageId;
						this._webSiteUrl = news.WebSiteUrl;
						if (callback) {
							callback();
						}
					}.bind(this),
					function () {
						if (callback) {
							callback();
						}
					}
				);
			}
		};

		NewsDialog.prototype.buildNews = function () {
			if (this._messageDate && this._headerImage && this._content) {
				// header image
				var months = Absolute.StringManager('months', null, true);
				var newsImageContainer = document.getElementById("newsimage");
				var newsDateContainer = document.getElementById("newsdate");
				var headerImage = document.createElement("img");
				headerImage.src = this._headerImage;
				newsImageContainer.innerHTML = "";
				newsDateContainer.innerHTML = months[this._messageDate.getMonth()] + ' '
					+ this._messageDate.getDate() + ', ' + this._messageDate.getFullYear();
				newsImageContainer.appendChild(headerImage);

				// content
				var newsFrame = document.getElementById("newsframe");
				newsFrame.contentWindow.document.open();

				// ugly hack to prevent pinch zooming
				this._content += "<scr" + "ipt>" +
					"document.documentElement.addEventListener('touchstart', function(event){" +
					//                    "if(event.touches.length > 1 || parent.updateTouches(false) > 1) {" +
					"if(event.touches.length > 1) {" +
					"event.preventDefault();" +
					"}" +
					"});" +
					//                "document.documentElement.addEventListener('touchend', function(event){" +
					//                    "console.log('touch end iframe');" +
					//                    "parent.updateTouches(true)" +
					//                "});" +
					"</scr" + "ipt>";

				this._content += "<scr" + "ipt>" +
					"var aTags = document.getElementsByTagName('a');" +
					"if(aTags && aTags.length > 0) aTags[0].onclick = function (e) {" +
					"e.preventDefault();window.open(e.target.href);" +
					"};" +
					"</scr" + "ipt>";

				newsFrame.contentWindow.document.write(this._content);
				newsFrame.contentWindow.document.close();

				this.overlayContainer.style.display = "block";
				this.news.style.display = "block";
				this.newsOverlay.style.display = "block";
				SettingsManager.setSetting('motd', this._id, true);
				return true;
			} else if (this._webSiteUrl) {
				window.open(this._webSiteUrl);
			}
			return false;
		};

		NewsDialog.prototype.hide = function () {
			this.overlayContainer.style.display = "none";
			this.news.style.display = "none";
			this.newsOverlay.style.display = "none";
			if (typeof this.closeCallback === 'function') {
				this.closeCallback();
			}
			if (this._webSiteUrl) {
				window.open(this._webSiteUrl);
			}
		};

		return NewsDialog;

	});

